export const ContractAddr = "0xA728392F25cFf07d86Fe889767606eDc5017b784"
export const ContractAddrAir = "0xaA1Fe0ab779f6AFb76690f0C58ED3dA579E8dA2A"
export const CHAIN = 1
export const CHAINAir = 1